import React, { Fragment } from "react";
import Link from "next/link";
import Image from "next/image";
import express from "../../../public/img/express.png";
import Planeexpress from "../../assets/images/Plane-Animation-Desktop.gif";
import styles from "@/styles/home.module.scss";
const Expressdelivery = () => {
  return (
    <Fragment>
      <section className={styles.bg_express}>
          <Link
                        href="/jewellery/category/all-products?fastDelivery=true"
                        passHref
                      >
         <Image src={Planeexpress} className="w-100" />
         </Link>
        {/* <div className={`${styles.container} ${"container"}`}>
         
          <div className={styles.express}>
            <div className="row pointer align-items-center g-0">
              <div className="col-md-3 col-lg-3">
                <div className={styles.express_head}>
                  <div className={styles.express_head_text}>
                    Express Delivery
                  </div>
                </div>
              </div>

              <div className=" col-md-6 col-lg-6">
                <div className={styles.shipping}>
                  <div className={styles.exp_text}>
                    <p>
                      Excited to See Products available for
                      Express Delivery?{" "}
                      <Link
                        href="/jewellery/category/all-products?fastDelivery=true"
                        passHref
                      >
                        Click Now
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className=" col-md-3 col-lg-3">
                <div className={styles.exp_img}>
                  <Image
                    className="img-fluid"
                    src={require("@/assets/images/express-delivery-main.gif")}
                    alt="Logo"
                    width={464}
                    height={120}
                    priority
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </Fragment>
  );
};

export default Expressdelivery;
